import React from 'react';
import styled from 'styled-components';

import Hero from './components/Hero';
import Services from './components/Services';
import Offers from './components/Offers';
import Reviews from './components/Reviews';

function Dealer() {
  return (
    <Component>
      <Hero />
      <Services />
      <Offers />
      <Reviews />
    </Component>
  );
}

export default Dealer;

const Component = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.white};
`;
